import { render, staticRenderFns } from "./GigSubmissionsReviewTable.vue?vue&type=template&id=3677ea8e&scoped=true&"
import script from "./GigSubmissionsReviewTable.vue?vue&type=script&lang=js&"
export * from "./GigSubmissionsReviewTable.vue?vue&type=script&lang=js&"
import style0 from "./GigSubmissionsReviewTable.vue?vue&type=style&index=0&id=3677ea8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3677ea8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon})
